<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col>Grupos de Eixo</v-col>
      <v-col class="text-align-center add">
        <v-btn color="primary" class="ml-3" @click="add()"> Adicionar </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="value"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td>
                <div v-if="item.edit">
                  <v-text-field
                    name="nome"
                    type="text"
                    required
                    v-model="item.nome"
                    :rules="rules"
                  ></v-text-field>
                </div>

                <div v-else>
                  {{ item.nome }}
                </div>
              </td>
              <td>
                <div v-if="item.edit" class="autocomplete">
                  <autocomplete
                    :filter="item"
                    :payloadEixos="eixos"
                    :rules="rules"
                  ></autocomplete>
                </div>
                <div v-else>
                  <div
                    v-for="eixo in getEixoName(JSON.parse(item.eixoIds))"
                    :key="eixo"
                  >
                    {{ eixo }}
                  </div>
                </div>
              </td>
              <td>
                <div class="acoes" v-if="!item.edit">
                  <ModalDeleteGroup
                    :payload="item"
                    @onDelete="load()"
                  ></ModalDeleteGroup>

                  <div class="edit" @click="edit(item, index)">
                    <v-icon style="color: green">mdi-pencil</v-icon>
                  </div>
                </div>

                <div v-else>
                  <v-row>
                    <v-btn
                      type="button"
                      color="error"
                      text
                      @click="cancel(item, index)"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      type="button"
                      color="primary"
                      @click="save(item, index)"
                    >
                      Salvar
                    </v-btn>
                  </v-row>
                </div>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span> Nenhum Grupo de Eixo </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col style="text-align: end">
        <button @click="saveConfig()">salvar</button>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppYesOrNOCombobox from "./Combobox";
import { eixosGrupoAPI } from "../API/eixosGrupoApi";
import Autocomplete from "../../eixo/components/Autocomplete.vue";
import { eixoAPI } from "@/modules/eixo/API/eixoAPI";
import ModalDeleteGroup from "./ModalDelete.vue";

export default {
  components: {
    AppYesOrNOCombobox,
    Autocomplete,
    ModalDeleteGroup,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome", width: "40%" },
        { text: "Eixos", value: "eixoIds", width: "40%" },
        { text: "Ações", value: "acoes" },
      ],
      initialValue: JSON.parse(localStorage.getItem("config")),
      value: [],
      allValues: [],
      payload: {},
      search: "",
      eixos: [],
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },

  methods: {
    ...mapActions(["setLoading", "setConfig"]),
    add() {
      if (this.value.filter((item) => item.edit).length == 0) {
        this.value = [
          {
            nome: "",
            eixosIds: [],
            edit: true,
          },
          ...this.value,
        ];
      } else {
        this.$notification.error("Adicione um grupo por vez");
      }
    },
    edit(item, index) {
      this.value[index].edit = true;
    },
    getEixoName(eixoIds) {
      return this.eixos
        .filter((item) => eixoIds.some((ei) => ei === item.eixoId))
        .map((item) => item.nome);
    },
    cancel(item, index) {
      this.load();
    },
    loadEixos() {
      eixoAPI
        .list()
        .then((resp) => {
          this.eixos = resp.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter Eixos");
        });
    },
    load() {
      this.setLoading(true);

      eixosGrupoAPI
        .get()
        .then(({ data }) => {
          this.value = data.map((item) => {
            return {
              ...item,
              eixosIds: item.eixoIds && JSON.parse(item.eixoIds),
              edit: false,
            };
          });
          this.allValues = data.map((item) => {
            return {
              ...item,
              eixosIds: item.eixoIds && JSON.parse(item.eixoIds),
              edit: false,
            };
          });
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },

    async save(item, index) {
      var finalGrupo = item;
      finalGrupo.eixoIds = JSON.stringify(finalGrupo.eixosIds);
      if (!finalGrupo.nome || finalGrupo.eixosIds.length === 0) {
        this.$notification.error("Nome e Eixo obrigatórios!");
        return;
      }
      this.setLoading(true);

      if (finalGrupo.eixoGrupoId) {
        eixosGrupoAPI
          .update(finalGrupo)
          .then(() => {
            this.load();
          })
          .catch(() => {
            this.setLoading(true);
          });
      } else {
        eixosGrupoAPI
          .create(finalGrupo)
          .then(() => {
            this.load();
          })
          .catch(() => {
            this.setLoading(true);
          });
      }
    },
  },

  mounted() {
    this.load();
    this.loadEixos();
  },

  computed: {
    ...mapGetters(["isFullAdmin", "config"]),
  },
};
</script>

<style scoped lang="scss">
.add {
  justify-content: flex-end;
  display: flex;
}
.acoes {
  display: flex;
}
.edit {
  border: 1px solid green;
  padding: 0 16px;
  height: 36px;
  display: flex;
  border-radius: 5px;
  cursor: pointer;
}

.autocomplete {
  padding-top: 24px;
}
</style>
